(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/Collection', './PatientInsuranceModel', 'services/patientExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var patientExtService = require('./../urls').patientExtService;
    module.exports = factory(require('underscore'), require('backbone-torso/modules/Collection'), require('./PatientInsuranceModel'), patientExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, TorsoCollection, PatientInsuranceModel, patientExtService) {
  'use strict';

  /**
   * Receives insurance from the InsuranceExtService which serves the InsuranceDTO resource
   * @class InsuranceCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: PatientInsuranceModel,
    url: function() {
      return patientExtService + '/' + this._patientVecnaId + '/insurance';
    },
    fetchHttpAction: 'POST',

    /**
     * @method initialize
     * @param attributes {Object}
     * @param options {Object}
     *   @param options.patientVecnaId {String} the patient vecna id that this collection is bound to.
     * @override
     */
    initialize: function(attributes, options) {
      options = options || {};
      this.setPatientVecnaId(options.patientVecnaId);
    },

    /**
     * Updates the patient id to a new value.
     * @method setPatientVecnaId
     * @param patientVecnaId the vecna id of the patient to track for this collection.
     */
    setPatientVecnaId: function(patientVecnaId) {
      if (this._patientVecnaId !== patientVecnaId) {
        this._patientVecnaId = patientVecnaId;
        this.reset();
        this.fetch();
      }
    },

    fetchIdsByCriteria: function(criteria) {
      return $.ajax({
        url: _.result(this, 'url') + '/criteria',
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(criteria)
      });
    }
  }))();
}));
